var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 809 809",
    width: 809,
    height: 809,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M874.5 741.9C874.5 741.9 874.5 741.9 874.5 741.9C874.5 743.24 874.5 743.99 874.5 744.14C874.5 744.14 874.5 744.14 874.5 744.14C296.7 744.14 -24.3 744.14 -88.5 744.14C-88.5 744.14 -88.5 744.14 -88.5 744.14C-88.5 742.79 -88.5 742.04 -88.5 741.9C-88.5 741.9 -88.5 741.9 -88.5 741.9C489.3 741.9 810.3 741.9 874.5 741.9Z",
    id: "d4TZLHss9u"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7 358.38C122.7 358.38 79.51 392.32 101.11 400.03C101.11 400.03 136.59 372.27 136.59 372.27C133.81 369.49 125.48 361.16 122.7 358.38Z",
    id: "a2P7uW8LiX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.25 346.04C118.69 355.3 115.61 360.44 114.99 361.47C114.99 361.47 130.42 361.47 133.5 384.61C134.33 383.58 138.44 378.44 145.84 369.18L124.25 346.04Z",
    id: "a27xc5Q1Be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.96 744.05L312.45 754.85L304.74 750.22L306.28 697.77L329.42 697.77L329.42 697.77L330.96 744.05Z",
    id: "bcDEbxvYo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.89 685.43L222.98 734.79L179.78 753.3C181.63 737.57 182.66 728.83 182.87 727.08C182.87 727.08 195.21 707.02 192.12 685.43C195.83 685.43 205.08 685.43 219.89 685.43Z",
    id: "k1rXvN1Thw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.23 313.65C286.23 313.65 310.91 378.44 315.54 418.55C315.54 418.55 327.88 565.1 327.88 565.1C328.91 574.25 334.05 620.02 343.31 702.4L300.11 708.57L281.6 569.73L239.95 432.43L230.69 569.73L222.98 694.68L182.87 696.22L179.78 566.64L162.81 401.58L172.07 322.9C232.95 317.97 271.01 314.88 286.23 313.65Z",
    id: "a4zxdBbd8g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37 747.13C309.37 747.13 311.9 721.22 330.69 735.72C330.91 735.56 332.03 734.73 334.05 733.25C343.31 753.61 348.45 764.92 349.48 767.19C349.48 767.19 367.99 793.41 335.59 796.5C335.59 796.5 306.28 767.19 306.28 767.19C306.08 766.26 305.05 761.63 303.2 753.3L304.74 744.21C307.21 745.77 308.75 746.74 309.37 747.13Z",
    id: "h2S1KeGrb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23 737.88C232.23 753.3 230.69 754.85 230.69 754.85C228.38 755.46 209.87 760.4 207.55 761.02C207.55 761.02 192.12 759.47 182.87 768.73C182.87 768.73 127.33 784.16 127.33 771.82C127.33 771.82 165.9 739.42 165.9 739.42C165.9 739.42 177.35 720.08 185.51 722.03C185.51 722.03 196.75 727.08 196.75 728.62C196.75 728.62 192.12 740.96 192.12 740.96C192.12 740.96 218.35 734.79 219.89 716.28C227.63 720.7 232.35 728.97 232.23 737.88Z",
    id: "b2zeELERZ3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.81 46.77C195.51 46.77 178.24 64.03 178.24 85.33C178.24 106.63 195.51 123.9 216.81 123.9C238.11 123.9 255.37 106.63 255.37 85.33C255.37 64.03 238.11 46.77 216.81 46.77Z",
    id: "cqr8Y77fy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.32 133.93C234.55 173.73 219.12 195.84 216.04 200.26C216.04 200.26 212.95 127.76 203.69 115.41C194.44 103.07 245.35 95.36 245.35 95.36C247.61 100.5 253.27 113.36 262.32 133.93Z",
    id: "b49Yvi73Ml"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.46 155.52L237.63 157.07L245.35 150.9L256.14 116.96L271.57 127.76L291.63 329.84L166.67 332.93L183.64 192.55L199.07 152.44L210.2 137.72L217.58 160.15L223.75 175.58L223.75 175.58L231.46 155.52Z",
    id: "b9PO6GLXiD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23 261.97C262.06 178.24 263.64 131.72 263.95 122.42C263.95 122.42 273.11 123.13 276.2 127.76C276.2 127.76 330.19 141.64 330.19 141.64C329.27 155.99 321.86 270.76 320.94 285.11C320.94 285.11 359.5 399.26 345.62 405.43C345.62 405.43 307.05 410.06 307.05 410.06C300.68 390.32 284.74 340.95 259.23 261.97Z",
    id: "hhxBYT0e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41 244.23L200.78 150.18L164.36 174.81L173.61 242.68C168.98 270.45 166.41 285.88 165.9 288.96C165.9 288.96 136.59 417 145.84 421.63C155.1 426.26 165.9 421.63 165.9 421.63C167.13 412.99 173.3 369.8 184.41 292.05L184.41 244.23Z",
    id: "c3XznBVwan"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.16 171.72L164.36 174.81L159.73 236.51L152.02 290.51C129.8 330.31 117.46 352.42 114.99 356.84C114.99 356.84 133.5 344.5 141.22 379.98C143.94 375.25 157.53 351.58 181.99 308.99L175.16 171.72Z",
    id: "eqLG0udMr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.48 346.04C295.48 346.04 252.29 379.98 273.89 387.69C273.89 387.69 309.37 359.93 309.37 359.93C306.59 357.15 298.26 348.82 295.48 346.04Z",
    id: "cdh9NMsRY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.82 379.98L289.31 347.58L297.03 333.7L321.71 363.01L321.71 363.01L307.82 379.98Z",
    id: "a1z9HV2HVE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.62 147.04C326.03 143.34 330.14 141.28 330.96 140.87C330.96 140.87 340.22 153.21 341.76 164.01C341.76 164.01 351.02 188.69 351.02 196.4C351.02 196.4 372.62 276.62 372.62 276.62C367.68 286.65 328.19 366.87 323.25 376.89C323.25 376.89 312.45 339.87 289.31 336.79C291.88 333.19 304.74 315.19 327.88 282.79L306.28 244.23L318.62 147.04Z",
    id: "f41lJuVM3S"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.37 45.68C256.37 45.68 241.16 28.93 220 30.39C220.6 29.73 225.36 24.49 225.95 23.84C225.95 23.84 211.41 18.02 198.18 33.3C191.23 41.34 183.19 50.78 178.18 61.42C177.66 61.42 175.06 61.42 170.39 61.42L173.64 68.58L162.26 75.74C169.27 74.96 173.16 74.54 173.94 74.45C173.24 78.37 173.14 82.37 173.62 86.32C174.12 90.27 176.14 93.88 179.25 96.37C179.25 96.37 179.25 96.37 179.25 96.37C179.25 96.37 188.27 77.7 188.27 74.79C188.27 75.52 188.27 81.34 188.27 82.07C188.27 82.07 195.54 75.52 195.54 71.15C195.8 71.49 197.13 73.19 199.51 76.25L201.49 68.24L225.95 76.25L221.99 69.7L237.19 71.88C233.62 67.07 231.64 64.41 231.24 63.87C231.24 63.87 248.43 73.33 249.09 81.34C249.75 89.35 254.79 96.93 254.79 96.93C254.79 96.93 268.27 59.5 249.09 48.59C250.55 48 255.64 45.97 256.37 45.68Z",
    id: "o2hxeVfO72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.75 79.16C252.75 82.14 250.82 84.56 248.43 84.56C246.05 84.56 244.11 82.14 244.11 79.16C244.11 76.18 246.05 73.76 248.43 73.76C250.82 73.76 252.75 76.18 252.75 79.16Z",
    id: "b4uUVoFWc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4TZLHss9u",
    opacity: 1,
    fill: "#3f3d56",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d4TZLHss9u",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2P7uW8LiX",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2P7uW8LiX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a27xc5Q1Be",
    opacity: 1,
    fill: "#cfcce0",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a27xc5Q1Be",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcDEbxvYo",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bcDEbxvYo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1rXvN1Thw",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k1rXvN1Thw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4zxdBbd8g",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a4zxdBbd8g",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2S1KeGrb",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2S1KeGrb",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2zeELERZ3",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2zeELERZ3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cqr8Y77fy",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cqr8Y77fy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b49Yvi73Ml",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b49Yvi73Ml",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9PO6GLXiD",
    opacity: 1,
    fill: "#cfcce0",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b9PO6GLXiD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hhxBYT0e4",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hhxBYT0e4",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3XznBVwan",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3XznBVwan",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eqLG0udMr",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eqLG0udMr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cdh9NMsRY",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cdh9NMsRY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1z9HV2HVE",
    opacity: 1,
    fill: "#cfcce0",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1z9HV2HVE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f41lJuVM3S",
    opacity: 1,
    fill: "#575a89",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f41lJuVM3S",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o2hxeVfO72",
    opacity: 1,
    fill: "#2f2e41",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o2hxeVfO72",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4uUVoFWc",
    opacity: 1,
    fill: "#ffb8b8",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4uUVoFWc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.2c7462e64128ea8ae60e88aafadea005.svg";
export { ForwardRef as ReactComponent };